import { ensureRemote } from './runtime';

export const getOverridesFromQuery = (): Record<string, string> => {
  const { search } = window.location;

  const query = new URLSearchParams(search);
  const overridesMap = new Map<string, string>();

  for (const [key, value] of query.entries()) {
    if (ensureRemote(key)) {
      overridesMap.set(key, value);
    }
  }

  return Object.fromEntries(overridesMap);
};
